export default __webpack_public_path__ + "static/media/play_icon.8075b1ab.svg";